import React from "react";
import { authenticationService } from '_services';

const LineLiff = (props) => {

    const liffId = {
        tele: '1654063801-PwXBy90W', tele2: '1654063801-2Na3K7jR', profile: '1654063801-mPYn4Dba', booking: '1654063801-bZdLjP3w', register: '1654063801-P8KQYgGn', phr: '1654063801-79NgdqBO'}
    const redirect = (props.match.params.redirect !== undefined) ? "/" + props.match.params.redirect : "/tele";
    
    const liff = window.liff;


    var _liffid = "";
    if (redirect == '/tele')
        _liffid = liffId.tele
    else if (redirect == '/tele2')
        _liffid = liffId.tele2
    else if (redirect == '/booking')
        _liffid = liffId.booking
    //else if (redirect == '/register')
    //    _liffid = liffId.register
    else if (redirect == '/phr')
        _liffid = liffId.phr
    else
        _liffid = liffId.profile

    liff.init({
        //liffId: (redirect == '/tele') ? liffId.tele : liffId.profile
        liffId: _liffid
    })
    .then(() => {

        if (liff.isLoggedIn()) {

            liff.getProfile().then(function (profile) {


                authenticationService.login(profile.userId, profile.userId)
                    .then(
                        user => {

                            if (user.isActive == 1) {
                                const { from } = props.location.state || { from: { pathname: redirect } };
                                props.history.push(from);
                            }
                            else {
                                const { from } = props.location.state || { from: { pathname: "/profile/" + _liffid } };
                                props.history.push(from);
                            }

                        },
                        error => {
                            const { from } = props.location.state || { from: { pathname: "/lineregister/" + _liffid } };
                            props.history.push(from);
                        }
                    );


            }).catch(function (error) {
                window.alert('Id:' + _liffid + ' Error getting profile: ' + error);
            });

        }
        else {
            alert('0.');
        }
    })
    .catch((err) => {

    });

  return (
      <>
 
          <img
              alt="..."
              src={require("assets/img/ts_logo_xl.png")}
              style={{
                  maxHeight: '100%',
                  maxWidth: '100%',
                  width: 'auto',
                  height: 'auto',
                  position: 'absolute',
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  margin: 'auto',
              }}
      >
          </img>
    </>
  );
}

export default LineLiff;
